import React from 'react';
import { Text, Box } from '@landr/maestro';
import { css } from '@landr/styled-system/css';

export interface LetterArtworkProps {
    name: string;
}

const letterArtworkStyles = css({
    position: 'relative',
    width: '100%',
    height: '100%',
    textAlign: 'center',
    padding: '18%',
    userSelect: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});

export const LetterArtwork: React.FC<LetterArtworkProps> = ({ name }) => {
    return (
        <Box className={letterArtworkStyles}>
            <Text textStyle="headline-sm" color="text.medium">
                {name.charAt(0)}
            </Text>
        </Box>
    );
};

LetterArtwork.displayName = 'LetterArtwork';

export default LetterArtwork;
